/* eslint-disable react/jsx-filename-extension */
import React from 'react'

import { Auth0Provider } from '@auth0/auth0-react'
import { ThemeProvider } from '@wicadu/arepa/ui'
import { ScannerProvider } from '@wicadu/scanner-js'

import colors from '@constants/theme-colors'

export const wrapRootElement = ({ element }) => (
  <Auth0Provider
    domain={process.env.AUTH0_DOMAIN}
    clientId={process.env.AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: process.env.ASSISTANT_WEBAPP_HOST,
      audience: process.env.API_GATEWAY_HOST,
    }}
  >
    <ThemeProvider colors={colors}>
      <ScannerProvider>
        {element}
      </ScannerProvider>
    </ThemeProvider>
  </Auth0Provider>
)
